import {
  selectAvailableCheckInOptionsByUuidSelector,
  selectTenantOverridesByUuidSelector,
} from 'store/building-settings/selectors';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { currentUser } from 'store/user/selectors';
import type { CheckInOption, TenantBuildingSettingsOverride } from 'store/building-settings/types';

interface UseCheckInOptionsDataResponse {
  availableCheckInOptions: CheckInOption;
  tenantOverride: TenantBuildingSettingsOverride;
}

export const useCheckInOptionsData = (): UseCheckInOptionsDataResponse => {
  const params = useParams<{ ownerId: string }>();
  const buildingUuid = params.ownerId;

  const availableCheckInOptionsSelector = useMemo(
    () => selectAvailableCheckInOptionsByUuidSelector(buildingUuid || ''),
    [buildingUuid],
  );
  const tenantOverridesSelector = useMemo(
    () => selectTenantOverridesByUuidSelector(buildingUuid || ''),
    [buildingUuid],
  );

  const availableCheckInOptions = useSelector(availableCheckInOptionsSelector);
  const tenantOverrides = useSelector(tenantOverridesSelector);
  const userCompanyUuid = useSelector(currentUser)?.company_uuid;
  const tenantOverride = tenantOverrides.find((override) => override.tenant.uuid === userCompanyUuid);

  return { availableCheckInOptions, tenantOverride };
};
